import { gql } from "@apollo/client";

// Query for getAllFinanceTreeItems
export const GET_ALL_FINANCE_TREE_ITEMS = gql`
  query GetAllFinanceTreeItems {
    getAllFinanceTreeItems {
      id
      level
      serialNumber
      name
      nameAr
      slug
    }
  }
`;

